import { render } from "./NotificacionesRegistro.vue?vue&type=template&id=1e460af5"
import script from "./NotificacionesRegistro.vue?vue&type=script&lang=js"
export * from "./NotificacionesRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__